// services/licenseService.js
const API_URL = 'https://apienglish.nguyenluan.vn/api';

const LicenseService = {
    // Lấy danh sách tất cả license (admin)
    getAllLicenses: async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Không có token xác thực');
            }

            const response = await fetch(`${API_URL}/licenses`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Token không hợp lệ. Vui lòng đăng nhập lại.');
                } else if (response.status === 403) {
                    throw new Error('Bạn không có quyền truy cập trang admin.');
                } else {
                    throw new Error('Không thể tải danh sách license.');
                }
            }

            const data = await response.json();
            return {
                success: true,
                data: data.data || []
            };
        } catch (error) {
            console.error('Get all licenses error:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Tạo license mới (admin)
    createLicense: async (licenseData) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Không có token xác thực');
            }

            const response = await fetch(`${API_URL}/licenses`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(licenseData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Không thể tạo license');
            }

            const data = await response.json();
            return {
                success: true,
                data: data.data
            };
        } catch (error) {
            console.error('Create license error:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Cập nhật license (admin)
    updateLicense: async (licenseId, updateData) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Không có token xác thực');
            }

            const response = await fetch(`${API_URL}/licenses/${licenseId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(updateData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Không thể cập nhật license');
            }

            const data = await response.json();
            return {
                success: true,
                data: data.data
            };
        } catch (error) {
            console.error('Update license error:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Xóa license (admin)
    deleteLicense: async (licenseId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Không có token xác thực');
            }

            const response = await fetch(`${API_URL}/licenses/${licenseId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Không thể xóa license');
            }

            return {
                success: true,
                message: 'Xóa license thành công'
            };
        } catch (error) {
            console.error('Delete license error:', error);
            return {
                success: false,
                error: error.message
            };
        }
    },

    // Kiểm tra license key (cho user đăng ký)
    validateLicense: async (licenseKey) => {
        try {
            const response = await fetch(`${API_URL}/licenses/validate/${licenseKey}`);

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'License không hợp lệ');
            }

            const data = await response.json();
            return {
                success: true,
                data: data.data
            };
        } catch (error) {
            console.error('Validate license error:', error);
            return {
                success: false,
                error: error.message
            };
        }
    }
};

export default LicenseService;
